import { APIClient } from "./axiosClient";

export interface TransferListPayload {
    startDateInMillis?: string;
    endDateInMillis?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    transferStatus?: string | null;
    transferStatuses?: string[];
    transferPartnerId?: string;
    programId?: string | null;
    pageNumber: number;
    pageSize: number;
    id?: string;
    transferPartnerTransactionId?: string;
}

export interface TransferTransactionVO {
    id: number;
    transferTransactionId: string;
    transferDate: string;
    transferAmount: number;
    transferCurrency: string;
    transferStatus: string;
    fromProgramVO: {
        id: number;
        programCode: string;
        programName: string;
    };
    toProgramVO: {
        id: number;
        programCode: string;
        programName: string;
    };
    transferPartnerVO: {
        id: number;
        partnerCode: string;
        partnerName: string;
    };
    // Add any other fields you get from the API
}

export interface TransferListResponse {
    transferTransactionsDataVO?: {
        totalNumberOfTransactions?: number;
        transferTransactionVOs?: TransferTransactionVO[];
    };
    transferTransactionStatsVOS?: {
        totalNumberOfTransactions?: number;
        totalAmountOfTransactions?: number;
        totalSuccessfulTransactions?: number;
        totalSuccessfulTransactionAmount?: number;
        totalPointsEarned?: number;
        totalPointsRedeemed?: number;
        avgPointsPerTransaction?: number;
        currencyVO?: {
            iso3CurrencyCode?: string;
            currencyName?: string;
            currencySymbol?: string;
            id?: number;
        } | null;
    };
}

export interface TransferPartnerListPayload {
    country?: string | null;
    transferPartnerName?: string | null;
    pageNumber: number;
    pageSize: number;
    sortOrder: 'asc' | 'desc';
    sortBy: string;
}

export interface TransferPartnerVO {
    id: number;
    createdDateInMillis: number;
    lastUpdatedDateInMillis: number;
    partnerCode: string;
    partnerName: string;
    clientId: number;
    clientVO: {
        id: number;
        clientCode: string;
        currencyVO: {
            iso3CurrencyCode: string;
            currencyName: string;
            currencySymbol: string;
            id: number;
        };
        clientName: string;
        clientAddress: string;
        clientContactNumber: string;
        clientCountry: string;
        createDate: string;
        lastUpdatedDate: string;
    };
    taxId: string;
    businessLocation: string;
    currencyId: number;
    currencyVO: {
        iso3CurrencyCode: string;
        currencyName: string;
        currencySymbol: string;
        id: number;
    };
    websiteUrl: string;
    businessDescription: string;
    country: string;
    city: string;
    costPerPoint: number;
    loyyalProfitPercentage: number;
    partnerLogoUri: string;
    pointsIncrement: number;
    computeFromSidePointsAutomatically: boolean;
    xssAttack: boolean;
}

export interface TransferPartnerListResponse {
    totalNumberOfTransferPartners: number;
    transferPartnerVOList: TransferPartnerVO[];
}

export interface ProgramAssignmentDataResponse {
    transferPartnerId: number;
    assignedPrograms: any[];
    unAssignedPrograms: any[];
}

export class TransferApi {
    static getTransferTransactionsFromDB(payload: TransferListPayload) {
        return APIClient(
            '/transfer/getTransferTransactionsFromDB',
            payload,
            { requestType: 'post' }
        );
    }

    static getTransferTransactionsDashboardFromDB(payload: TransferListPayload) {
        return APIClient(
            '/transfer/getTransferTransactionsDashboardFromDB',
            payload,
            { requestType: 'post' }
        );
    }

    static getTransferPartnersFromDB(payload: TransferPartnerListPayload) {
        return APIClient(
            '/transferPartner/getTransferPartnersFromDB',
            payload,
            { requestType: 'post' }
        );
    }

    static createOrUpdateTransferPartner(payload: any) {
        return APIClient(
            '/transferPartner/createOrUpdateTransferPartner',
            payload,
            { requestType: 'post' }
        );
    }

    static getProgramAssignmentDataFromDB(payload: { transferPartnerId: number; pageNumber?: number; pageSize?: number; country?: string; programName?: string; programType?: string; }) {
        return APIClient(
            '/transferPartner/getProgramAssignmentDataFromDB',
            payload,
            { requestType: 'post' }
        );
    }

    static assignProgramsToTransferPartner(assignments: any[]) {
        return APIClient(
            '/transferPartner/assignProgramsToTransferPartner',
            assignments,
            { requestType: 'post' }
        );
    }

    static unAssignProgramsFromTransferPartner(transferPartnerProgramIds: number[]) {
        return APIClient(
            '/transferPartner/unAssignProgramsFromTransferPartner',
            transferPartnerProgramIds,
            { requestType: 'post' }
        );
    }
} 